import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-title">Terms of Service</h1>
      <p className="effective-date">Effective Date: May 24, 2025</p>

      <p className="terms-intro">
        By using our platform, you agree to these legally binding terms. If you don't agree, you must not use our services.
      </p>

      <section className="terms-section">
        <h2 className="section-title">1. Our Role</h2>
        <div className="section-content">
          <p>We provide a platform for home cooks and local buyers to connect, communicate, and transact. We don't cook, sell, deliver, or control food in any way.</p>
        </div>
      </section>

      <section className="terms-section">
        <h2 className="section-title">2. User Responsibilities</h2>
        <div className="section-content">
          <p>You agree to:</p>
          <ul>
            <li>Follow your local food and health regulations.</li>
            <li>Use our platform respectfully and lawfully.</li>
            <li>Not upload harmful, misleading, or unrelated content.</li>
          </ul>
        </div>
      </section>

      <section className="terms-section">
        <h2 className="section-title">3. Listings & Content</h2>
        <div className="section-content">
          <p>You may upload content (e.g., food images, descriptions, pricing), but:</p>
          <ul>
            <li>It must reflect reality — no people or off-topic content.</li>
            <li>You grant us a license to use it to promote your offerings or improve the platform.</li>
            <li>We may remove or moderate content at our discretion.</li>
          </ul>
        </div>
      </section>

      <section className="terms-section">
        <h2 className="section-title">4. Transactions</h2>
        <div className="section-content">
          <p>Cooks are responsible for preparing and fulfilling their own orders.</p>
          <p>Buyers are responsible for reviewing all relevant info before placing an order.</p>
          <p>We simply provide the payment and booking infrastructure.</p>
          <p>Refunds may be:</p>
          <ul>
            <li>Offered by the cook directly</li>
            <li>Approved by us in rare cases of non-delivery or significant misrepresentation</li>
          </ul>
        </div>
      </section>

      <section className="terms-section">
        <h2 className="section-title">5. Disputes</h2>
        <div className="section-content">
          <p>We're not liable for disputes between users.</p>
          <p>We may step in as a neutral party but do not guarantee resolutions.</p>
        </div>
      </section>

      <section className="terms-section">
        <h2 className="section-title">6. Limitation of Liability</h2>
        <div className="section-content">
          <p>We are not liable for:</p>
          <ul>
            <li>Foodborne illness, allergies, or injuries</li>
            <li>Business losses or emotional harm</li>
            <li>Any issues arising offline or from user interactions</li>
          </ul>
          <p>Use of the platform is entirely at your own risk.</p>
        </div>
      </section>

      <section className="terms-section">
        <h2 className="section-title">7. Termination</h2>
        <div className="section-content">
          <p>We may suspend or remove access if:</p>
          <ul>
            <li>You violate these terms or our policies</li>
            <li>You threaten the safety, integrity, or trust of the community</li>
          </ul>
        </div>
      </section>

      <section className="terms-section">
        <h2 className="section-title">8. Updates</h2>
        <div className="section-content">
          <p>We may update these terms over time. Continuing to use the platform after changes means you accept the new version.</p>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
